export const monitorMenuDeprecatedRouteMap = {
  "/customers/:customerId/known-issues": "/customers/:customerId/monitor/cloud-incidents",
  "/customers/:customerId/known-issues/:knownIssueId": "/customers/:customerId/monitor/cloud-incidents/:knownIssueId",

  "/customers/:customerId/anomaly": "/customers/:customerId/monitor/cost-anomalies",
  "/customers/:customerId/anomaly/:assetId/:alertId": "/customers/:customerId/monitor/cost-anomalies/:assetId/:alertId",

  "/customers/:customerId/analytics/alerts": "/customers/:customerId/monitor/alerts",
  "/customers/:customerId/analytics/alerts/labels": "/customers/:customerId/monitor/alerts/labels",
  "/customers/:customerId/analytics/alerts/create": "/customers/:customerId/monitor/alerts/create",
  "/customers/:customerId/analytics/alerts/:alertId": "/customers/:customerId/monitor/alerts/:alertId",

  "/customers/:customerId/analytics/budgets": "/customers/:customerId/monitor/budgets",
  "/customers/:customerId/analytics/budgets/labels": "/customers/:customerId/monitor/budgets/labels",
  "/customers/:customerId/analytics/budgets/create": "/customers/:customerId/monitor/budgets/create",
  "/customers/:customerId/analytics/budgets/:budgetId": "/customers/:customerId/monitor/budgets/:budgetId",
  "/customers/:customerId/analytics/budgets/:budgetId/view": "/customers/:customerId/monitor/budgets/:budgetId/view",

  // ramp plans no longer exist, and will redirect to commitment manager
  "/customers/:customerId/contracts/ramps": "/customers/:customerId/monitor/commitment-manager",
  "/customers/:customerId/contracts/ramps/:rampId": "/customers/:customerId/monitor/commitment-manager",
  "/customers/:customerId/monitor/ramp-plans": "/customers/:customerId/monitor/commitment-manager",
  "/customers/:customerId/monitor/ramp-plans/:rampId": "/customers/:customerId/monitor/commitment-manager",
};
